import React, {Component}  from 'react';
import ReactDOM from 'react-dom';
import {Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import './index.css';
import App from './App';
import {PersistGate} from 'redux-persist/lib/integration/react';
import registerServiceWorker from './registerServiceWorker';
import store, {persistor} from './store';
import history from './history';


class AppProvider extends Component {

  render() {
    return (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router history={history}>
            <App />
          </Router>
        </PersistGate>
      </Provider>
    )
  }
}

ReactDOM.render(
  <AppProvider/>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js